<template>
  <div :class="widgetData.container">
    <div class="row">
      <div id="acc_list_1_3" class="acc_list_1_3 col-12 px-3">
        <div class="section-title my-4 my-xl-4 my-xxl-5" v-if="widgetData.description">
          <h2 v-html="widgetData.description" v-if="widgetData.description"></h2>
        </div>


        <div class="splide splide-detail-similar" v-if="content.length > 0" ref="splideContainer">

          <div class="splide__track">
            <div class="splide__list">
              <div class="splide__slide" v-for="accommodation in content"
                   :key="widget.id + 'acc_item_' + accommodation.id"
                   :data-index="accommodation.id">

                <WidgetAccommodationListAccList13Item :accommodation="accommodation" :activeLocale="activeLocale"
                                                      :activeCountry="activeCountry" :widgetName="widgetData.title"
                                                      :currency="activeLocaleCurrency"
                                                      :GATrackEvent="GATrackEvent"/>

              </div>
            </div>
          </div>
        </div>

        <div class="row" v-else>
          <div class="col-12">
            <div class="alert alert-info">
              {{ $t('there-is-no-accommodation-in-list') }}
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import "~/assets/less/acc_list_1_3.min.css";
import {useNuxtApp} from "#app";
import {onMounted, PropType, ref} from "vue";
import {PageDataHolderFetchedWidget} from "~/lib/interfaces/model/PageDataHolderFetchedWidget";
import {useWidget} from "~/composables/widget/accommodation_list";
import {obtainActiveLocale} from "../../../../composables/master_page";
import Accommodation from "../../../../lib/models/Accommodation";
import {useRoute, useRouter} from "#app";
import PlaceCountry from "../../../../lib/models/PlaceCountry";
import {GATracker} from "../../../../composables/ga_tracker";

const {$vysklonujSlovo, $tyrionApi, $splide} = useNuxtApp();
const props = defineProps({
  widget: Object as PropType<PageDataHolderFetchedWidget>
});

const page = ref(0);
const loading = ref(false);
const splideContainer = ref(null);
const {widgetData, content, activeLocale, activeLocaleCurrency, activeCountry} = useWidget(props.widget);
const {GATrackEvent} = GATracker();


onMounted(async () => {
  const Splide = await $splide();
  const splide = new Splide(splideContainer.value, {
    type: 'loop',
    perPage: 5,
    perMove: 1,
    autoplay: true,
    gap: '1rem',
    drag: true,

    breakpoints: {

      490: {
        perPage: 1,
        padding: {left: '1rem', right: '4rem'},
        pagination: false,
        arrows: false,
      },

      640: {
        perPage: 2,
        padding: {left: '1rem', right: '4rem'},
        pagination: false,
        arrows: false,
      },

      1024: {
        perPage: 2,
        pagination: false,
        arrows: false,
      },

      1300: {
        perPage: 3,
        pagination: false,
        arrows: false,
      },
    }

  }).mount();
});
</script>
